export const INITIALIZE_APP = 'initialize_app';
export const ADD_TO_SCENE = 'add_to_scene';
export const SET_DATASOURCE = 'set_datasource';
export const ADD_TO_SCENE_BULK = 'add_to_scene_bulk';
export const ADD_PAGE = 'add_page'
export const SET_PAGE_STATE = 'set_page_state';
export const ADD_TO_DRAG_ELEMENTS = 'add_to_drag_elements';
export const ADD_TO_DRAG_ELEMENTS_ALL = 'add_to_drag_elements_all';
export const REMOVE_ALL_DRAG_ELEMENTS = 'remove_all_drag_elements';
export const REMOVE_DRAG_ELEMENTS = 'remove_drag_elements';
export const DROP_ELEMENT = 'drop_element';
export const DROP_ELEMENT_ALL = 'drop_element_all';
export const DROP_ELEMENT_BULK = 'drop_element_bulk';
export const MAKE_ELEMENT_ACTIVE = 'make_element_active';
export const CHANGE_PROPERTIES = 'change_properties';
export const CHANGE_PROPERTIES_BY_ID = 'change_properties_by_id';
export const CHANGE_PROPERTIES_BY_ID2 = 'change_properties_by_id2';
export const CHANGE_PROPERTIES_BY_ID3 = 'change_properties_by_id3';
export const CHANGE_PROPERTIES_RANGE = 'change_properties_range';
export const DOUBLE_CLICK = 'double_click';
export const UPDATE_ELEMENT = 'update_element';
export const UPDATE_VALUES = 'change_values';
